import styles from './styles.module.scss';
import {ReactComponent as NotificationIcon} from '../../assets/img/noun-email-notification-6235193.svg';
import {ReactComponent as ScanIcon} from '../../assets/img/noun-scan-4730275.svg';
import {ReactComponent as PassIcon} from '../../assets/img/noun-pass-2086048.svg';
import {ReactComponent as OrderIcon} from '../../assets/img/noun-food-6228546.svg';
import {ReactComponent as ReceiptIcon} from '../../assets/img/noun-receipt-997787.svg';
import {ReactComponent as ToolkitIcon} from '../../assets/img/noun-caesar-cipher-3085845.svg';
import CopilotsIcon from '../../assets/img/copilotsIcon.png';
import {ReactComponent as ReferIcon} from '../../assets/img/noun-guidance-4728800.svg';
import {ReactComponent as LogoutIcon} from '../../assets/img/noun-exit-2696258.svg';
import { Typography } from '@mui/material';

const UserNavPad=({showNotifications,confirmLogout})=>{
  return (
    <>
      <div onClick={showNotifications}>
          <NotificationIcon /> 
          <Typography variant="userNavDrawerNotificationAlert">1 new notification</Typography>
      </div>
      <ul>
        <li> 
          <ScanIcon />
          <Typography variant="userNavPadItem">Scanner</Typography>
        </li>
        <li>
          <PassIcon />
          <Typography variant="userNavPadItem">Badge</Typography>
        </li>
        <li>
          <OrderIcon />
          <Typography variant="userNavPadItemTwoLine">Orders & Reservations</Typography>
        </li>
        <li>
          <ReceiptIcon />
          <Typography variant="userNavPadItemTwoLine">History/ Receipts</Typography>
        </li>
        <li>
          <ToolkitIcon />
          <Typography variant="userNavPadItem">Toolkit</Typography>
        </li>
        <li>
          <img src={CopilotsIcon} />
          <Typography variant="userNavPadItem">Copilots</Typography>
        </li>
        <li>
          <ReferIcon />
          <Typography variant="userNavPadItemTwoLine">Refer Friends</Typography>
        </li>
        <li>
          <ScanIcon />
          <Typography variant="userNavPadItemTwoLine">Profile Settings</Typography>
        </li>
        <li onClick={confirmLogout}>
          <LogoutIcon />
          <Typography variant="userNavPadItem">Logout</Typography>
        </li>
      </ul>
    </>
  )
}

export default UserNavPad